import styled from "styled-components";

const StyledRadio = styled.input`
  display: inline;
  width: fit-content;
`;

interface RadioInputProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  value: string | number;
  /**  All radio buttons for one field must share the same `name`. */
  name: string;
  id?: string;
}

const RadioInput = ({ checked, onChange, label, value, name, id }: RadioInputProps) => (
  <>
    <StyledRadio
      type="radio"
      id={id ?? `${name}-${value}`}
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
    />
    <label style={{ width: "auto" }} htmlFor={id ?? `${name}-${value}`}>
      {label}
    </label>
  </>
);

export default RadioInput;
